import carousel1 from '../../assets/carousel1.webp';
import carousel2 from '../../assets/carousel2.webp';
import carousel3 from '../../assets/carousel3.webp';
import favicon from '../../assets/favicon.webp';
import styles from './TypesOfContentSection.module.css';

const contentLinks = [
  {
    id: 1,
    image: carousel1,
    title: 'YouTube Videos',
    number: '01',
    link: 'https://www.youtube.com/@samanthashenolguin',
    colorClass: styles.numberOne,
  },
  {
    id: 2,
    image: carousel3,
    title: 'Instagram Posts',
    number: '02',
    link: 'https://www.instagram.com/samanthashenolguin',
    colorClass: styles.numberTwo,
  },
  {
    id: 3,
    image: carousel2,
    title: 'TikTok Feed',
    number: '03',
    link: 'https://www.tiktok.com/@samanthashenolguin',
    colorClass: styles.numberThree,
  },
];

const TypesOfContentSection = () => {
  return (
    <section className={styles.section}>
      <div className={styles.circleWrapper}>
        <img src={favicon} alt="circle decoration" className={styles.faviconCircle} />
      </div>
      <h2 className={styles.heading}>types of content</h2>
      <div className={styles.cardContainer}>
        {contentLinks.map((item) => (
          <a
            key={item.id}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.card}
          >
            <img src={item.image} alt={item.title} className={styles.image} />
            <div className={styles.textContainer}>
              <span className={`${styles.number} ${item.colorClass}`}>
                {item.number}
              </span>
              <span className={styles.title}>{item.title}</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default TypesOfContentSection;